import React from "react";
import {Mail, PhoneCall, Clock3, MapPin} from "lucide-react";

export const Contact = () => {
    return (
        <section className='contact-section' id='contact'>

            <div className='section-content'>
                <div className='contact-panel'>
                    <h2 className='section-title'>Get In Touch</h2>
                    <p className='contact-intro'>
                    Whether your vehicle needs routine maintenance, engine diagnostics, brake service, or collision repairs, our experienced technicians are here to help. Contact us today to schedule your appointment.
                    </p>

                    <div className='contact-list'>
                        <a href='tel:+16235216105' className='contact-row contact-call-button'>
                            <span className='contact-icon'><PhoneCall/></span>
                            <span className='contact-text'>623-521-6105</span>
                        </a>

                        <a href='mailto:mariogonzo23@gmail.com' className='contact-row'>
                            <span className='contact-icon'><Mail/></span>
                            <span className='contact-text'>mariogonzo23@gmail.com</span>
                        </a>

                        <div className='contact-row'>
                            <span className='contact-icon'><Clock3/></span>
                            <span className='contact-text'>Monday - Saturday, 8am-5:30pm </span>
                        </div>

                        <div className='contact-row'>
                            <span className='contact-icon'><MapPin/></span>
                            <span className='contact-text'>Phoenix, Arizona</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
